import { Property } from "src/api/sure-api/ssq/useGetOneSsq";

export const manageTooltipText = <T>(generator: (coalescedText: string) => T, property: Property): T | undefined => {
    // legacy hints were being used as tooltips for child properties: preserve behaviour for child properties when no helper_text but a hint
    const coalesceTooltipText =
        property.parent && !property.helperText && property.hint ? property.hint : property.helperText;
    return coalesceTooltipText ? generator(coalesceTooltipText) : undefined;
};
